var map = {
	"./template.bet575": 1888,
	"./template.bet575.tsx": 1888,
	"./template.bet777": 1889,
	"./template.bet777.tsx": 1889,
	"./template.betblast": 1890,
	"./template.betblast.tsx": 1890,
	"./template.betgalaxy": 1891,
	"./template.betgalaxy.tsx": 1891,
	"./template.betprofessor": 1892,
	"./template.betprofessor.tsx": 1892,
	"./template.betroyale": 2136,
	"./template.betroyale.tsx": 2136,
	"./template.betstride": 1893,
	"./template.betstride.tsx": 1893,
	"./template.buffalobet": 1894,
	"./template.buffalobet.tsx": 1894,
	"./template.chromabet": 1895,
	"./template.chromabet.tsx": 1895,
	"./template.default": 55,
	"./template.default.tsx": 55,
	"./template.fiestabet": 1896,
	"./template.fiestabet.tsx": 1896,
	"./template.forsport": 1897,
	"./template.forsport.tsx": 1897,
	"./template.gigabet": 1898,
	"./template.gigabet.tsx": 1898,
	"./template.goldenbet888": 1899,
	"./template.goldenbet888.tsx": 1899,
	"./template.goldenrush": 1900,
	"./template.goldenrush.tsx": 1900,
	"./template.hyperbet": 1901,
	"./template.hyperbet.tsx": 1901,
	"./template.juicybet": 1902,
	"./template.juicybet.tsx": 1902,
	"./template.junglebet": 1903,
	"./template.junglebet.tsx": 1903,
	"./template.magnumbet": 1904,
	"./template.magnumbet.tsx": 1904,
	"./template.oldgill": 1905,
	"./template.oldgill.tsx": 1905,
	"./template.puntcity": 1906,
	"./template.puntcity.tsx": 1906,
	"./template.puntgenie": 2022,
	"./template.puntgenie.tsx": 2022,
	"./template.pyramidbet": 1907,
	"./template.pyramidbet.tsx": 1907,
	"./template.questbet": 2137,
	"./template.questbet.tsx": 2137,
	"./template.slambet": 1908,
	"./template.slambet.tsx": 1908,
	"./template.sterlingparker": 2138,
	"./template.sterlingparker.tsx": 2138,
	"./template.sugarcastle": 1909,
	"./template.sugarcastle.tsx": 1909,
	"./template.templebet": 1910,
	"./template.templebet.tsx": 1910,
	"./template.titanbet": 1911,
	"./template.titanbet.tsx": 1911,
	"./template.ts": 998,
	"./template.vikingbet": 1912,
	"./template.vikingbet.tsx": 1912,
	"./template.volcanobet": 1913,
	"./template.volcanobet.tsx": 1913,
	"./template.wellbet": 1914,
	"./template.wellbet.tsx": 1914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2786;